var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNextSingle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 13,
    cy: 13,
    r: 13,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M12.5232 9.56261C12.2079 9.25086 11.7004 9.25086 11.3851 9.56262V9.56262C11.152 9.79303 11.0809 10.1412 11.205 10.4446L11.9404 12.243C12.0932 12.6166 12.1696 12.8034 12.1696 13C12.1696 13.1966 12.0932 13.3834 11.9404 13.757L11.205 15.5554C11.0809 15.8588 11.152 16.207 11.3851 16.4374V16.4374C11.7004 16.7491 12.2079 16.7491 12.5232 16.4374L14.5614 14.4223C15.2389 13.7525 15.5777 13.4176 15.5777 13C15.5777 12.5824 15.2389 12.2475 14.5614 11.5777L12.5232 9.56261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNextSingle);
export default __webpack_public_path__ + "static/media/icon-next-single.f2f847649c6a026257f47dd92d99eaa2.svg";
export { ForwardRef as ReactComponent };